export default __webpack_public_path__ + "static/media/warning_icon.36cdb57c.svg";